import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'm-machine-pos',
  props: {
  position: {
    type: String,
    default: '左下角',
  },
  idKey: {
    type: String,
    default: '',
  },
},
  emits: ['onPositionChange'],
  setup(__props, { emit: emits }) {

const props = __props



const handleClickPos = (pos: string) => {
  emits('onPositionChange', pos)
}



return { __sfc: true,emits, handleClickPos, props }
}

})